var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "BlBackdrop",
    {
      attrs: {
        title: "Previous recurring schedules",
        label: "Add " + _vm.schedulesInput.length + " schedule(s)",
        submitLoading: _vm.submitLoading,
        disabled: _vm.isDisabledSubmit
      },
      on: {
        "backdrop-close": function($event) {
          return _vm.$emit("close-modal")
        },
        "backdrop-action": _vm.onSubmit
      }
    },
    [
      _c(
        "div",
        { staticClass: "flex flex-col gap-2", style: { width: "40rem" } },
        [
          _c("div", { staticClass: "flex flex-col gap-2 px-8" }, [
            _c(
              "div",
              [
                _c("BlTextBody2", {
                  attrs: {
                    text:
                      "Select schedules from recent records to include in the recurring appointments. You can modify them later if needed."
                  }
                })
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass:
                  "flex items-center gap-2 pb-2 overflow-x-auto scrollbar-lg"
              },
              _vm._l(_vm.dayOptions, function(day) {
                return _c(
                  "div",
                  {
                    key: day,
                    staticClass:
                      "px-2 py-1 transition-all duration-300 rounded-full cursor-pointer hover:text-pure-white hover:bg-light-purple",
                    class: [
                      _vm.dayInput === day
                        ? "text-pure-white bg-light-purple-400"
                        : "text-slate-800 bg-slate-200"
                    ],
                    on: {
                      click: function($event) {
                        return _vm.onChangeDay(day)
                      }
                    }
                  },
                  [
                    _c("span", { staticClass: "text-sm capitalize" }, [
                      _vm._v("\n            " + _vm._s(day) + "\n          ")
                    ])
                  ]
                )
              }),
              0
            )
          ]),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "px-8 overflow-y-auto",
              style: { maxHeight: "calc(100vh - 24rem)" }
            },
            [
              _vm.fetchLoading
                ? _c("div", { staticClass: "grid h-80 place-items-center" }, [
                    _c("div", { staticClass: "blum-loader" })
                  ])
                : !_vm.previousSchedules.length
                ? _c(
                    "div",
                    { staticClass: "grid text-center h-80 place-items-center" },
                    [
                      _vm.dayInput === "all"
                        ? _c("BlTextBody2", {
                            attrs: {
                              text:
                                "No recent schedules available. Once you create recurring appointments for this client, they will appear here."
                            }
                          })
                        : _c("BlTextBody2", {
                            attrs: {
                              text:
                                "No recent schedules available for this day."
                            }
                          })
                    ],
                    1
                  )
                : _c(
                    "div",
                    { staticClass: "flex flex-col gap-3 min-h-80" },
                    _vm._l(_vm.previousSchedules, function(schedule) {
                      return _c(
                        "div",
                        {
                          key: schedule.id,
                          staticClass:
                            "flex gap-2 px-2 py-2 border rounded border-slate-400",
                          class: { "opacity-50": !schedule.is_available }
                        },
                        [
                          _c(
                            "div",
                            { staticClass: "pt-1" },
                            [
                              _c("BlInputCheck", {
                                attrs: {
                                  checked: _vm.isChecked(schedule.id),
                                  disabled: !schedule.is_available
                                },
                                on: {
                                  changed: function($event) {
                                    return _vm.onChangeCheck(schedule)
                                  }
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("div", { staticClass: "flex flex-col gap-2" }, [
                            _c(
                              "div",
                              { staticClass: "truncate w-132" },
                              [
                                _c("BlTextSubtitle3", {
                                  attrs: { text: "Every " + schedule.day }
                                }),
                                _vm._v(" "),
                                _c("BlTextSubtitle3", {
                                  attrs: {
                                    text:
                                      schedule.start_time_string +
                                      " - " +
                                      schedule.end_time_string
                                  }
                                }),
                                _vm._v(" "),
                                _c("BlTextSubtitle3", {
                                  staticClass: "truncate",
                                  attrs: {
                                    text:
                                      (schedule.user && schedule.user.name) ||
                                      "No therapist assigned"
                                  }
                                })
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "flex items-center gap-3" },
                              [
                                _c(
                                  "div",
                                  { staticClass: "flex items-center gap-2" },
                                  [
                                    _vm.enableBranch && schedule.room.branch
                                      ? _c(
                                          "div",
                                          {
                                            staticClass:
                                              "flex items-center justify-center px-2 rounded h-7 max-w-32",
                                            style: {
                                              backgroundColor:
                                                schedule.room.branch
                                                  .background_color || "unset"
                                            }
                                          },
                                          [
                                            _c("BlTextBody2", {
                                              staticClass: "truncate",
                                              style: {
                                                color:
                                                  schedule.room.branch.color ||
                                                  "unset"
                                              },
                                              attrs: {
                                                text:
                                                  schedule.room.branch.name ||
                                                  "-"
                                              }
                                            })
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _c("BlTextBody2", {
                                      staticClass: "text-slate-700",
                                      attrs: { text: schedule.room.name }
                                    })
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c("div", {
                                  staticClass:
                                    "flex-shrink-0 w-1 h-1 rounded bg-slate-600"
                                }),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  [
                                    _c("BlTextBody2", {
                                      staticClass: "text-slate-700",
                                      attrs: { text: schedule.total_credit }
                                    }),
                                    _vm._v(" "),
                                    _c("BlTextBody2", {
                                      staticClass: "text-slate-700",
                                      attrs: { text: "credit(s) of" }
                                    }),
                                    _vm._v(" "),
                                    schedule.credit_transaction_services.length
                                      ? _c("BlTextBody2", {
                                          staticClass: "text-slate-700",
                                          attrs: {
                                            text:
                                              schedule
                                                .credit_transaction_services[0]
                                                .package_item_name
                                          }
                                        })
                                      : _vm._e()
                                  ],
                                  1
                                )
                              ]
                            )
                          ])
                        ]
                      )
                    }),
                    0
                  )
            ]
          ),
          _vm._v(" "),
          _vm.totalPreviousSchedules > _vm.perPage
            ? _c(
                "div",
                { staticClass: "px-8" },
                [
                  _c("BlInputPagination", {
                    attrs: {
                      page: _vm.page,
                      count: Math.ceil(_vm.totalPreviousSchedules / _vm.perPage)
                    },
                    on: { changed: _vm.changePage }
                  })
                ],
                1
              )
            : _vm._e()
        ]
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-efad41ec", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-efad41ec","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/appointments/modal/PreviousRecurringSchedulesModal.vue
// module id = null
// module chunks = 